import { changeAntdTheme } from 'mini-dynamic-antd-theme';

const changePrimaryThemeColour = (colour) => {
  changeAntdTheme(colour);
};

export default changePrimaryThemeColour;
